import { JSError } from './JSError';
import type { TJSErrorParams } from './const';

type TGenericErrorExtras = {
  //
};

export class GenericError extends JSError<TGenericErrorExtras> {
  constructor(params: Omit<TJSErrorParams<TGenericErrorExtras>, 'name'>) {
    super({
      ...params,
      name: 'GenericError',
    });
  }
}
